import AbstractConfig from './AbstractConfig';

export default class GalleryBannerConfig extends AbstractConfig {
  public caption(): string {
    return this.get('caption');
  }

  public basename(): string {
    return this.get('basename');
  }
}
